<template>
  <div class="instant-search-wrapper">
    <TInputText
      name="fuzzy-search-bar"
      placeholder="Search articles..."
      :icon="searchIcon"
      autocomplete="off"
      @update:model-value="onInput"
    />
    <div v-if="suggestions.length" class="search-results-wrapper">
      <div
        v-for="suggestion in suggestions"
        :key="suggestion.id"
        data-testid="search-suggestion"
      >
        <slot
          name="suggestion-link"
          :suggestion="suggestion"
          :highlight-split-tag="highlightSplitTag"
        >
        </slot>
      </div>
    </div>
    <div v-else-if="showEmpty" class="italic pt-4">No results found.</div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import TInputText from '../forms/TInputText/TInputText.vue'
import { setup } from './controller'
import { SEARCH_PROPS } from './types'

export default defineComponent({
  components: {
    TInputText,
  },
  props: SEARCH_PROPS,
  setup,
})
</script>
